<template>
  <section>   
    <b-row > 
      <b-col>
            <validation-observer v-slot="{ invalid } ">     
              <b-card > 
                <template v-slot:header >
                  <div class="header-card">
                    Registrar Aporte Servicios
                  </div> 
                </template> 
                
                <b-nav tabs>
                  <b-nav-item :active="active===0" @click="resetDataGet();searchSw.value='';active=0">Afiliados otros servicios</b-nav-item>                
                </b-nav>  
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6;">
                  <br>
                  <!-- Afiliado -->
                    <div v-if="active===0" class="p-1"> 
                      <b-row align-v="center"> 
                          <sw-searchs
                            label='Seleccionar afiliado'
                            list='datos_afiliado'
                            @input="searchsData('afiliado')"
                            :filter="{campo: 'id_list_estado', value: 1}"
                          >
                          </sw-searchs>  
                          <b-col>
                            <b-button @click="searchSw.value=''" style="margin-top:10px" size="sm">Limpiar</b-button>
                          </b-col>
                      </b-row> 
                      <div  v-if="searchSw.value!='' &&  statusDescargar">                       
                        <b-row> 
                          <b-col :md="5">
                              <h5 class="title-form">Datos Afiliado</h5>
                              <b-row>                               
                                <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="id_datos_razon"
                                :md="6" :lg="6">
                                </sw-inputs>                          
                                <sw-inputs
                                inputTabla="info_afiliacion"
                                inputCampo="id_datos_asesor"
                                :md="6" :lg="6">
                                </sw-inputs>                        
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="id_list_documento"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="documento"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="nombre1"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="nombre2"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="apellido1"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="apellido2"
                                :md="6" :lg="6">
                                </sw-inputs>    
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="direccion"
                                :md="12" :lg="12">
                                </sw-inputs> 
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="ciudad"
                                :md="6" :lg="6">
                                </sw-inputs> 
                                <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="telefonos"
                                :md="6" :lg="6">
                                </sw-inputs>                             
                              </b-row>
                          </b-col> 
                          <b-col :md="7"  v-if="searchSw.value!=''">
                              <h5 class="title-form">Servicios</h5>                                
                              <sw-tablemultiple
                                  getTable="multiple_servicios"                                  
                                  :hideServicio="['Administración','Eps','Riesgo','Ccf','Afp','Traslado']"
                                  :views="[
                                    { th:'Select.', td: 'check'},
                                    { th:'Servicio', td: 'name'},
                                    { th:'Entidad', td: 'id_list'},
                                    { th:'Valor', td: 'valor'},
                                  ]"
                                  >
                                </sw-tablemultiple>  
                          </b-col>   
                        </b-row>
                        <b-col  class="card-footer">
                          <b-row>
                            <b-col :md="6" :lg="6" >
                              <p  class="text-danger" style="padding-top:10px"  v-if="errorsAportes!=='' && errorsAportes!==null">* {{errorsAportes}}</p>                              
                            </b-col>
                            <b-col  :md="4" :lg="4">
                              <b-row align-h="end">
                                <b-col
                                  :md="6"
                                  :lg="6">
                                  <b-form-group
                                    label="Mes Aporte"
                                  >
                                    <c-multiselect
                                      style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                      v-model="mesPeriodo"                   
                                      :options="lists.list_mes"
                                      label="name"
                                      track-by="name"
                                      :allow-empty="false"
                                      placeholder="Seleccionar"
                                      >
                                    </c-multiselect>
                                  </b-form-group>
                                </b-col>
                                <b-col
                                  :md="6"
                                  :lg="6">
                                  <b-form-group
                                    label="Año Aporte"
                                  >
                                    <c-multiselect
                                      style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                      v-model="anoPeriodo"                   
                                      :options="lists.list_ano"
                                      label="name"
                                      track-by="name"
                                      :allow-empty="false"
                                      placeholder="Seleccionar"
                                      >
                                    </c-multiselect>
                                  </b-form-group>
                                </b-col>                              
                              </b-row>     
                            </b-col>
                            <b-col :lg="2" :md="2" style="padding-top:25px">  
                              <sw-saveform
                              guardarFtn="afiliadoFtn"
                              :invalid="invalid || invalidNovedad()"
                              :index="dataIndex[namePath]"
                              :getBackendData="getBackendData"
                              @save="saveForm">
                              </sw-saveform>                               
                            </b-col>
                          </b-row>                                        
                        </b-col>  
                      </div>                        
                      <sw-loading v-if="searchSw.value!='' && statusDescargar===false"></sw-loading>        
                    </div>                  
                  <!-- loading -->
                </div>             
              </b-card>              
            </validation-observer>                   
      </b-col>
    </b-row> 
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      :hide-backdrop="!openModal.modal.loaded"
      :modal-class="{'d-none': !openModal.modal.loaded}"
      size="lg"  
      >        
        <sw-modalaportesservicios 
          v-if="openModal.modal.modal==='Aportes'"
          @save="saveForm"                     
          >
        </sw-modalaportesservicios>             
    </b-modal> 
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import { ValidationObserver } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
import SwModalaportesservicios  from '@/components/modals/aportesServicios.vue'

export default { 
  name: "aportes_registrar",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,    
    SwSaveform,
    SwTablemultiple,
    SwSearchs,
    SwLoading,
    'c-multiselect': Multiselect,  
    VueNumeric,    
    SwModalaportesservicios,
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>